export const escapeUnicodeToHtml = (input: string) => {
  // 1. Decode Unicode escapes first (\u003C -> <)
  let text = input.replace(/\\u([0-9a-fA-F]{4})/g, (_, grp) => String.fromCharCode(parseInt(grp, 16)));

  // 2. Map dangerous characters to entities
  const entityMap: Record<string, string> = {
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;',
    "'": '&#39;',
  };

  // 3. Convert EVERYTHING to safe entities first
  text = text.replace(/[<>&"']/g, (s) => entityMap[s]);

  // 4."preserve" the <br> tags so the parser can see them
  return text.replace(/&lt;br\s*\/?&gt;/gi, '<br>');
};
